<div class="footer">
  <div class="content">
    <div class="media">
      <app-logo />
      <div class="links">
        <a>
          <img src="assets/icons/facebook.svg" alt="" />
        </a>
        <a>
          <img src="assets/icons/telgram.svg" alt="" />
        </a>
        <a href="assets/icons/instagram.svg">
          <img src="assets/icons/instagram.svg" alt="" />
        </a>
      </div>
    </div>
    <div class="cols">
      <div class="quick-links">
        <span class="title">{{ 'footer.quick-links' | translate }}</span>
        <div class="items">
          <a routerLink="/workspace">{{ 'footer.workspace' | translate }}</a>
          <a routerLink="/requests">{{ 'footer.requests' | translate }}</a>
          <a routerLink="/services">{{ 'footer.services' | translate }}</a>
          <a *ngIf="!isParentUser" routerLink="/schools">{{
            'footer.my-schools' | translate
          }}</a>
        </div>
      </div>
      <div class="help">
        <span class="title">{{ 'footer.help-support' | translate }}</span>
        <div class="items">
          <a
            href="https://test.optimalpass.org/en/contact-us"
            target="_blank"
            >{{ 'footer.contact-us' | translate }}</a
          >
          <a>{{ 'footer.faq' | translate }}</a>
          <a>{{ 'footer.accessibility' | translate }}</a>
        </div>
      </div>
      <div class="tel">
        <span class="title">{{ 'footer.get-in-touch' | translate }}</span>
        <div class="items">
          <a class="muted">{{ 'footer.date' | translate }}</a>
          <a class="muted"> {{ 'footer.mobile' | translate }}</a>
        </div>
      </div>
    </div>
  </div>
  <hr />
  <div class="info">
    <a class="muted">{{ 'footer.rights' | translate }} </a>
    <div class="actions">
      <a>{{ 'footer.copyright' | translate }} </a>
      <a>{{ 'footer.terms-conditions' | translate }}</a>
      <a>{{ 'footer.disclaimer' | translate }}</a>
      <a>{{ 'footer.privacy-policy' | translate }}</a>
    </div>
  </div>
</div>
